import { Button, ResponsiveValue, Stack, ThemeComponents, ThemeTypings } from "@chakra-ui/react";
import * as CSS from 'csstype';
import { useEffect, useState } from "react";

interface SwitchButtonType {
    size?: ResponsiveValue<ThemeComponents extends keyof ThemeTypings["components"] ? ThemeTypings["components"] : string>,
    firstButtonText: string;
    secondButtonText: string;
    activeButtonColor: CSS.Property.Color;
    activeHoverColor: CSS.Property.Color;
    activeClickColor: CSS.Property.Color;
    inactiveButtonColor: CSS.Property.Color;
    inactiveHoverColor: CSS.Property.Color;
    inactiveClickColor: CSS.Property.Color;
    color: CSS.Property.Color;
    selected?: string;
    onClick?: (e: string) => void
}
export default function SwitchButton({
    size,
    firstButtonText,
    secondButtonText,
    activeButtonColor,
    activeHoverColor,
    activeClickColor,
    inactiveButtonColor,
    inactiveHoverColor,
    inactiveClickColor,
    color,
    selected,
    onClick
}: SwitchButtonType) {
    const [activeState, setActiveState] = useState<string>(firstButtonText);

    useEffect(() => {
        if (selected === firstButtonText || selected === secondButtonText) setActiveState(selected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (onClick) onClick(activeState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeState]);

    return (
        <Stack direction={'row'} spacing={0} color={color}>
            <Button
                size={size}
                bg={activeState === firstButtonText ? activeButtonColor : inactiveButtonColor}
                _hover={{ bg: activeState === firstButtonText ? activeHoverColor : inactiveHoverColor }}
                _active={{ bg: activeState === firstButtonText ? activeClickColor : inactiveClickColor }}
                roundedRight={'none'}
                onClick={e => setActiveState(firstButtonText)}
            >
                {firstButtonText}
            </Button>
            <Button
                size={size}
                bg={activeState === secondButtonText ? activeButtonColor : inactiveButtonColor}
                _hover={{ bg: activeState === secondButtonText ? activeHoverColor : inactiveHoverColor }}
                _active={{ bg: activeState === secondButtonText ? activeClickColor : inactiveClickColor }}
                roundedLeft={'none'}
                onClick={e => setActiveState(secondButtonText)}
            >
                {secondButtonText}
            </Button>
        </Stack>
    )
}